import React from 'react';
import { FiPenTool, FiType, FiImage, FiCalendar, FiRadio, FiCheckSquare } from 'react-icons/fi';
import '../styles/FieldPalette.css';

const FieldPalette = () => {
  const fields = [
    { type: 'signature', icon: FiPenTool, label: 'Signature', color: '#3B82F6' },
    { type: 'text', icon: FiType, label: 'Text Box', color: '#10B981' },
    { type: 'image', icon: FiImage, label: 'Image', color: '#F59E0B' },
    { type: 'date', icon: FiCalendar, label: 'Date', color: '#8B5CF6' },
    { type: 'radio', icon: FiRadio, label: 'Radio', color: '#EC4899' },
    { type: 'checkbox', icon: FiCheckSquare, label: 'Checkbox', color: '#14B8A6' },
  ];

  const handleDragStart = (e, fieldType) => {
    e.dataTransfer.effectAllowed = 'copy';
    e.dataTransfer.setData('fieldType', fieldType);
  };

  return (
    <div className="field-palette">
      <h3>Drag Fields to PDF</h3>
      <div className="field-grid">
        {fields.map((field) => {
          const Icon = field.icon;
          return (
            <div
              key={field.type}
              className="field-item"
              draggable
              onDragStart={(e) => handleDragStart(e, field.type)}
              style={{
                borderColor: field.color,
                cursor: 'grab',
              }}
            >
              <Icon size={24} style={{ color: field.color }} />
              <span>{field.label}</span>
            </div>
          );
        })}
      </div>
      <div className="palette-hint">
        <p>Tip: Drag any field onto the PDF to place it. Fields automatically adapt to mobile!</p>
      </div>
    </div>
  );
};

export default FieldPalette;
